(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const clock = root.querySelector('[data-countdown]');
    const note = root.querySelector('[data-date-note]');
    const raw = clock?.dataset.target || '';
    const target = /(?:Z|[+-]\d{2}:\d{2})$/.test(raw) ? Date.parse(raw) : NaN;
    let timer;
    const render = () => {
      if (!root.isConnected) { clearInterval(timer); return; }
      if (!Number.isFinite(target)) { note.textContent = 'DROP DATE TO BE ANNOUNCED'; return; }
      const seconds = Math.max(0, Math.floor((target - Date.now()) / 1000));
      const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
      ['days','hours','minutes','seconds'].forEach((key, i) => { clock.querySelector(`[data-${key}]`).textContent = String(values[i]).padStart(2,'0'); });
      if (!seconds) { note.textContent = clock.dataset.openText; clearInterval(timer); }
    };
    if (Number.isFinite(target)) timer = setInterval(render, 1000);
    render();
    const track = root.querySelector('[data-track]');
    const cards = [...root.querySelectorAll('.liv-card')];
    const dots = [...root.querySelectorAll('[data-slide]')];
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const current = () => Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    const go = index => track.scrollTo({left: Math.max(0, Math.min(cards.length - 1, index)) * track.clientWidth, behavior});
    if (track && cards.length) {
      const update = () => dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current())));
      root.querySelector('[data-prev]').addEventListener('click', () => go(current() - 1));
      root.querySelector('[data-next]').addEventListener('click', () => go(current() + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(current() + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      let drag;
      track.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = {x:e.clientX, scroll:track.scrollLeft};
        track.setPointerCapture(e.pointerId);
        track.style.scrollSnapType = 'none';
      });
      track.addEventListener('pointermove', e => {if(drag) track.scrollLeft = drag.scroll - (e.clientX - drag.x);});
      const finish = () => {if(!drag) return; drag = null; track.style.scrollSnapType = ''; go(current());};
      track.addEventListener('pointerup',finish);
      track.addEventListener('pointercancel',finish);
      update();
    }
    const dialog = root.querySelector('[data-password-dialog]');
    root.querySelector('[data-password-open]').addEventListener('click', () => dialog.showModal());
    root.querySelector('[data-password-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {if(event.target === dialog) dialog.close();});
    if(dialog.querySelector('[role="alert"]')) dialog.showModal();
  }
  document.querySelectorAll('[data-liv-closed]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-liv-closed]')));
})();
